"use client"
import { Button } from "@/registry/default/ui/button"
import { MoveLeft, FileQuestion } from "lucide-react"
import {RootHeader} from "@/components/root-header";
import React from "react";
import {useRouter} from "next/navigation";

export default function NotFound() {
    const router = useRouter()
    return (
        <main className="flex  w-full flex-col items-center text-center">
            <RootHeader title={'空页面'} back={true}/>
            <div className={'flex flex-col h-full gap-6 justify-center items-center text-center'}>
            <div className="flex flex-col items-center gap-2">
                <FileQuestion className="h-8 w-8" aria-hidden="true" />
                <h6 className="text-xl font-bold tracking-tight sm:text-2xl">页面不存在</h6>
                <p className="text-sm text-muted-foreground">你访问的页面不存在，请点击返回</p>
            </div>
            <Button onClick={()=>{
                router.back()
            }} size={'sm'} className={'rounded w-fit gap-2'}>
                    <MoveLeft className="h-4 w-3" />
                    返回
            </Button>
            </div>
        </main>
    )
}

